import React from 'react';

var RejectOffensivePopup = React.createClass({
	getInitialState: function(){
		return {offensive: {"derogatory_language": false,
						"sexual_explicit": false,
						"harassment": false,
						"hateful_content": false,
						"child_abuse": false,
						"unwanted_commercial_or_spam": false,
						"Other": false,
						"other": ""
					}
			}
	},
	handleCancelClick: function(){
		this.props.rejectOffensive("close");
		this.props.reject("open", this.props.data);
	},
	handleRejectClick: function(){
		var data = Object.assign(this.props.data, {})
		var data1 = Object.assign({"offensive": this.state.offensive}, data)
		this.props.rejectOffensive("submit", data1);
	},
	handleChange: function(name, e){
		var offensive = this.state.offensive;
		if(e.target.checked){
			offensive[name] = true;
		} else {
			offensive[name] = false;
		}
		this.setState({offensive: offensive});
	},
	handleTextChange: function(e){
		var offensive = this.state.offensive;
		offensive.other = e.target.value;
		this.setState({offensive: offensive});
	},
	handleOutsideClick: function(){
		this.props.rejectOffensive("close");
	},
	handleStopPropogation: function(e) {
		e.stopPropagation() 
	},
	render: function(){
		return(
			<div className="modal__mask" onClick = {this.handleOutsideClick}>
				<div className="modal__content modal--md" onClick = {this.handleStopPropogation}>
				  <div className="modal__header">
				    <h3 className="modal__header--title">What about this material is offensive to you?</h3>
				    <a href="javascript:void(0)" className="modal__close" onClick = {this.handleCancelClick}><i className="fa  fa-close"> </i></a> </div>
				  <div className="modal__body clearfix">
				    <div className="form__row clearfix">
				      <p>Your feedback is key in helping us weed out potential violators. Certain violations can result in account termination. Thanks htmlFor your help.</p>
				    </div>
				    <div className="form__row clearfix">
				      <ul className="reject__list list-unstyled">
				        <li className="reject__item checkbox">
				          <label htmlFor="a1">
				            <input id="a1" checked = {this.state.offensive["derogatory_language"]} name="check" type="checkbox" onChange = {this.handleChange.bind(this,"derogatory_language" )}/>
				            Derogatory language <span className="tooltip__container"><i className="fa fa-question-circle"> </i> <span className="tooltip tooltip--top tooltip--md">Content that is intended to hurt, demean or insult.</span></span></label>
				        </li>
				        <li className="reject__item checkbox">
				          <label htmlFor="a2">
				            <input id="a2" checked = {this.state.offensive["sexual_explicit"]} name="check" type="checkbox"  onChange = {this.handleChange.bind(this,"sexual_explicit" )}/>
				            Sexual explicit or pornographic content <span className="tooltip__container"><i className="fa fa-question-circle"> </i> <span className="tooltip tooltip--top tooltip--md">Includes graphically sexual activity, nudity, and/or other offensive sexual content.</span></span></label>
				        </li>
				        <li className="reject__item checkbox">
				          <label htmlFor="a3">
				            <input  id="a3" checked = {this.state.offensive["harassment"]} name="check" type="checkbox"  onChange = {this.handleChange.bind(this,"harassment" )}/>
				            Harassment or bullying <span className="tooltip__container"><i className="fa fa-question-circle"> </i> <span className="tooltip tooltip--top tooltip--md">Content that promotes abusive behavior toward groups or individuals, or engages in cyberbullying.</span></span></label>
				        </li>
				        <li className="reject__item checkbox">
				          <label htmlFor="a4">
				            <input  id="a4" checked = {this.state.offensive["hateful_content"]} name="check" type="checkbox"  onChange = {this.handleChange.bind(this,  "hateful_content" )}/>
				            Violent content <span className="tooltip__container"><i className="fa fa-question-circle"> </i> <span className="tooltip tooltip--top tooltip--md">Content that promotes graphic violence, or to shock users.</span></span></label>
				        </li>
				        <li className="reject__item checkbox">
				          <label htmlFor="a5">
				            <input  id="a5" checked = {this.state.offensive["child_abuse"]} name="check" type="checkbox"  onChange = {this.handleChange.bind(this, "child_abuse" )}/>
				            Child Abuse <span className="tooltip__container"><i className="fa fa-question-circle"> </i> <span className="tooltip tooltip--top tooltip--md">Content that promotes sexual, predatory or abusive aspects toward minors.</span></span></label>
				        </li>
				        <li className="reject__item checkbox">
				          <label htmlFor="a6">
				            <input id="a6" checked = {this.state.offensive["unwanted_commercial_or_spam"]} name="check" type="checkbox"  onChange = {this.handleChange.bind(this, "unwanted_commercial_or_spam" )}/>
				            Unwanted commercial content or spam <span className="tooltip__container"><i className="fa fa-question-circle"> </i> <span className="tooltip tooltip--top tooltip--md">Content that is misleading and without any true purpose.</span></span></label>
				        </li>
				        <li className="reject__item checkbox">
				          <label htmlFor="a7">
				            <input id="a7" checked = {this.state.offensive["Other"]} name="check" type="checkbox" onChange = {this.handleChange.bind(this, "Other")}/>
				            Other</label>
				        </li>
				      </ul>
				    </div>
				    {this.state.offensive["Other"] ?
				    <div className="form__row clearfix">
				    <textarea value = {this.state.offensive.other} onChange = {this.handleTextChange} />
				    </div> : null }
				    <div className="buttons clearfix">
				      <button className="btn__lg bg-very_light" onClick = {this.handleCancelClick}>Cancel</button>
				      <button className="btn__lg bg-bold" onClick = {this.handleRejectClick}>Reject</button>
				    </div>
				  </div>
				</div>
			</div>
			);
	}
});

export {RejectOffensivePopup};


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/RejectOffensivePopup.jsx
 **/